import { useController } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import type { Entries } from 'type-fest';

import { RadioButtonGroup, SettingsFormItem } from '@/modules/forms';
import { toLowerCase } from '@/utilities/string';

import { Fields } from '../../../constants';
import type { ImportFormValues } from '../../../schemas';
import { Delimiter } from '../../../types';

const options = Object.entries(Delimiter) as Entries<typeof Delimiter>;

const name = Fields.DELIMITER;

export const DelimiterField = () => {
    const {
        field: { ref, ...field },
    } = useController<ImportFormValues, typeof name>({ name });

    return (
        <SettingsFormItem name={name} label={<FormattedMessage id='import.form.delimiter.label' />}>
            <RadioButtonGroup
                {...field}
                optionType='button'
                options={options.map(([key, value]) => ({
                    label: <FormattedMessage id={`import.form.delimiter.${toLowerCase(key)}`} />,
                    value,
                }))}
                backgroundColor='backgroundsSecondary'
            />
        </SettingsFormItem>
    );
};
